import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpand = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#pet__clip0_1131_2717)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#AAAAAA",
			d: "M16.59 8.58997L12 13.17L7.41 8.58997L6 9.99997L12 16L18 9.99997L16.59 8.58997Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_1131_2717",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgExpand);
export default ForwardRef;
